var _ExternalPanelsNamespace_inputs;
import { __classPrivateFieldGet } from "tslib";
import { PrivateAPINamespace } from '../PrivateAPINamespace';
import { ExternalPanelsAPIErrorCode, createEditorPlatformPrivateAPIError, } from './errors';
import { InputsNamespace } from '../Inputs';
/**
 * @deprecated !!!
 */
export class ExternalPanelsNamespace extends PrivateAPINamespace {
    constructor() {
        super(...arguments);
        _ExternalPanelsNamespace_inputs.set(this, new InputsNamespace(this.hostType, this.ps));
        this.editorPointerAPI = (() => {
            if (!this.ps.editorPointerAPI) {
                throw createEditorPlatformPrivateAPIError(ExternalPanelsAPIErrorCode.EditorPointerAPINotProvided).withHostType(this.hostType);
            }
            return this.ps.editorPointerAPI;
        })();
    }
    async getExternalPanelsPrivateAPI() {
        return this.ps.hostAPI.getExternalPanelsPrivateAPI?.();
    }
    async getSingleSelectedOrThrow() {
        return this.ps.hostAPI.editor.selection.getSingleSelectedOrThrow();
    }
    async getComponentReferences() {
        const editorPointer = await this.getSingleSelectedOrThrow();
        const compRef = this.editorPointerAPI.getDocumentPointer(editorPointer);
        const innerElementPath = this.editorPointerAPI.getInnerElementPath(editorPointer);
        return { compRef, editorPointer, innerElementPath };
    }
    async getData() {
        const externalPanelsPrivateAPI = await this.getExternalPanelsPrivateAPI();
        if (externalPanelsPrivateAPI?.getData) {
            return externalPanelsPrivateAPI.getData();
        }
        const { compRef } = await this.getComponentReferences();
        return this.ps.ds.components.data.get(compRef);
    }
    async setData(newData) {
        const externalPanelsPrivateAPI = await this.getExternalPanelsPrivateAPI();
        if (externalPanelsPrivateAPI?.setData) {
            return externalPanelsPrivateAPI.setData(newData);
        }
        const { compRef } = await this.getComponentReferences();
        this.ps.ds.components.data.update(compRef, newData);
    }
    async getStyle() {
        const externalPanelsPrivateAPI = await this.getExternalPanelsPrivateAPI();
        if (externalPanelsPrivateAPI?.getStyle) {
            return externalPanelsPrivateAPI.getStyle();
        }
        const { compRef, editorPointer, innerElementPath } = await this.getComponentReferences();
        if (this.editorPointerAPI.isInnerElement(editorPointer)) {
            return this.ps.ds.components.innerElements.cssStyle.get(compRef, innerElementPath ?? []);
        }
        else {
            return this.ps.ds.components.cssStyle.get(compRef);
        }
    }
    async setStyle(newStyle) {
        const externalPanelsPrivateAPI = await this.getExternalPanelsPrivateAPI();
        if (externalPanelsPrivateAPI?.setStyle) {
            return externalPanelsPrivateAPI.setStyle(newStyle);
        }
        const { compRef, editorPointer, innerElementPath } = await this.getComponentReferences();
        if (this.editorPointerAPI.isInnerElement(editorPointer)) {
            this.ps.ds.components.innerElements.cssStyle.update(compRef, innerElementPath ?? [], newStyle);
        }
        else {
            this.ps.ds.components.cssStyle.update(compRef, newStyle);
        }
    }
    async getTheme() {
        const externalPanelsPrivateAPI = await this.getExternalPanelsPrivateAPI();
        if (externalPanelsPrivateAPI?.getTheme) {
            return externalPanelsPrivateAPI.getTheme();
        }
        const fonts = this.ps.ds.theme.fonts.getMap();
        const colors = this.ps.ds.theme.colors.getAll();
        return { fonts, colors, localImplementation: true };
    }
    async selectMedia(...options) {
        const externalPanelsPrivateAPI = await this.getExternalPanelsPrivateAPI();
        if (externalPanelsPrivateAPI?.selectMedia) {
            // @ts-expect-error deprecated
            return externalPanelsPrivateAPI.selectMedia(...options);
        }
        return __classPrivateFieldGet(this, _ExternalPanelsNamespace_inputs, "f").openMediaPanel(...options);
    }
    async selectLink(...options) {
        const externalPanelsPrivateAPI = await this.getExternalPanelsPrivateAPI();
        if (externalPanelsPrivateAPI?.selectLink) {
            // @ts-expect-error deprecated
            return externalPanelsPrivateAPI.selectLink(...options);
        }
        return __classPrivateFieldGet(this, _ExternalPanelsNamespace_inputs, "f").openLinkPanel(...options);
    }
    async selectColor(...options) {
        const externalPanelsPrivateAPI = await this.getExternalPanelsPrivateAPI();
        if (externalPanelsPrivateAPI?.selectColor) {
            // @ts-expect-error deprecated
            return externalPanelsPrivateAPI.selectColor(...options);
        }
        return __classPrivateFieldGet(this, _ExternalPanelsNamespace_inputs, "f").openColorPicker(...options);
    }
    async translate(key, values) {
        const externalPanelsPrivateAPI = await this.getExternalPanelsPrivateAPI();
        if (externalPanelsPrivateAPI?.translate) {
            return externalPanelsPrivateAPI.translate(key, values);
        }
        return null;
    }
}
_ExternalPanelsNamespace_inputs = new WeakMap();
ExternalPanelsNamespace.namespace = 'externalPanels';
//# sourceMappingURL=ExternalPanelsNamespace.js.map